import { cache } from 'react';
import { Article } from '../types/Header';

export type FetchArticlesResponse = {
  articles: Article[];
  totalPages: number;
};

export const fetchArticles = cache(
  async (
    page?: number,
    searchQuery?: string,
    lang?: string,
    url?: string,
    category?: string
  ): Promise<FetchArticlesResponse> => {
    try {
      const params = new URLSearchParams();

      if (page) {
        params.set('page', String(page));
      }
      if (searchQuery) {
        params.set('query', searchQuery);
      }
      if (lang) {
        params.set('lang', lang);
      }
      if (category) {
        params.set('category', category);
      }

      const response = await fetch(`${url ?? ''}/api/articles?${params.toString()}`);

      if (!response.ok) {
        throw new Error('Failed to fetch articles');
      }

      return await response.json();
    } catch (error) {
      console.error(error);
      return { articles: [], totalPages: 1 };
    }
  }
);
